"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.____LawRef = void 0;
const __1 = require("..");
class ____LawRef extends __1.EL {
    tag = "____LawRef";
    get isControl() { return true; }
    attr;
    constructor(options) {
        super("____LawRef", {}, [], options.range);
        const { includingDeclarationID, suggestedLawTitle, lawNum } = options;
        this.attr = {
            ...((includingDeclarationID !== undefined)
                ? { includingDeclarationID }
                : {}),
            ...((suggestedLawTitle !== undefined)
                ? { suggestedLawTitle }
                : {}),
            lawNum,
        };
    }
}
exports.____LawRef = ____LawRef;
//# sourceMappingURL=lawRef.js.map